import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { ApiInspectionDto, ApiRelatedActivityDto } from 'kes-common';

import { relatedActivityRegenerateReport } from '@/net/api';

interface MutationOptions {
	relatedActivityId: ApiRelatedActivityDto['id'];
}

const useRelatedActivityRegenerateReport = (
	inspectionId: ApiInspectionDto['id'],
	options?: UseMutationOptions<ApiRelatedActivityDto, unknown, MutationOptions>,
) =>
	useMutation(
		({ relatedActivityId }) =>
			relatedActivityRegenerateReport(relatedActivityId, inspectionId).then((response) =>
				response.expectSuccess(),
			),
		options,
	);

export default useRelatedActivityRegenerateReport;
